












































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  Alert,
  Company,
  Brand,
  Product,
  ComparisonGroup,
  ProductSector,
  ProductCategory,
  ProductClass,
  Media,
} from "@/models";
import MultiLevelObject from "@/interfaces/MultiLevelObject";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import ComparisonGroupSelect from "@/components/ComparisonGroupSelect.vue";
import EntrySelect from "@/components/EntrySelect.vue";
import VCheckButton from "@/components/VCheckButton.vue";
import VCheckButtonRadio, {
  VCheckButtonRadioOptions,
} from "@/components/VCheckButtonRadio.vue";
import TaxonomyValue from "@/interfaces/TaxonomyValue";
import TaxonomySelectV2 from "@/components/TaxonomySelectV2.vue";
import AlertMixin from "@/mixins/http/Alert";
import MediaSelect from "@/components/MediaSelect.vue";
import MediaValue from "@/interfaces/MediaValue";

const REQUEST_TAG = "alert";

@Component({
  components: {
    MultiLevelSelect,
    ComparisonGroupSelect,
    TaxonomySelectV2,
    EntrySelect,
    MediaSelect,
    VCheckButton,
    VCheckButtonRadio,
  },
})
export default class AlertEditor extends Mixins(AlertMixin) {
  @Prop() readonly value!: Alert;
  @Getter("userMedia") readonly userMedia!: MediaValue;

  alert: Alert = new Alert({});

  recipientFormVisible = false;
  recipient = "";

  entry: Company | Brand | Product | null = null;
  group: ComparisonGroup | null = null;
  taxonomies: TaxonomyValue = {
    sector: [],
    category: [],
    class: [],
  };

  alertableTypeOptions: MultiLevelObject[] = [
    {
      id: "comparisonGroups",
      text: "Gruppo",
    },
    {
      id: "companies",
      text: "Singolo",
    },
    {
      id: "userTaxonomies",
      text: "Settore/Categoria/Classe",
    },
  ];

  typeOptions: MultiLevelObject[] = [
    {
      id: "alertLaunches",
      text: "Partenza nuova campagna",
    },
  ];

  frequencyOptions: VCheckButtonRadioOptions = {
    never: "Mai",
    daily: "Quotidianamente",
    weekly: "Settimanalmente",
  };

  media = {
    tv: false,
    radio: false,
  };

  busy = false;

  get saveDisabled(): boolean {
    if (!this.alert.name) {
      return true;
    }

    if (this.isComparisonGroup) {
      return this.group == null;
    } else if (this.isEntry) {
      return this.entry == null;
    }

    return false;
  }

  created() {
    this.alert = this.value.clone();

    if (this.alert.isComparisonGroup) {
      this.group = this.alert.alertables[0] as ComparisonGroup;
    } else if (this.alert.isEntry) {
      this.entry = this.alert.alertables[0] as Company;
    } else if (this.alert.isTaxonomy) {
      this.taxonomies = this.getAlertablesToTaxonomies();
    }
    if (this.alert.id) {
      this.media.radio = this.alert.isRadio;
      this.media.tv = this.alert.isTV;
    } else {
      this.media = { ...this.userMedia };
    }
  }

  mounted() {
    if (!this.alert.id) {
      (this.$refs.inputName as HTMLInputElement).focus();
    }
  }

  addRecipient() {
    this.alert.recipients.push(this.recipient);
    this.hideRecipientForm();
  }

  removeRecipient(recipient: string) {
    const index = this.alert.recipients.indexOf(recipient);

    if (index >= 0) {
      this.alert.recipients.splice(index, 1);
    }
  }

  get isComparisonGroup() {
    return this.alert.isComparisonGroup;
  }

  get isEntry() {
    return this.alert.isEntry;
  }

  get isTaxonomy() {
    return this.alert.isTaxonomy;
  }

  protected async save() {
    if (this.isComparisonGroup && this.group) {
      this.alert.alertables = [this.group];
    } else if (this.isEntry && this.entry) {
      this.alert.alertables = [this.entry];
    } else {
      this.alert.alertables = this.getTaxonomiesToAlertables();
    }

    if (this.media.radio && this.media.tv) {
      this.alert.media = null;
    } else {
      const media = new Media({});
      media.id = this.media.radio ? "1" : "2";
      this.alert.media = media;
    }

    this.busy = true;

    try {
      if (this.alert.id) {
        await this.updateAlert(
          this.alert.id,
          this.alert.getPostData(),
          REQUEST_TAG
        );
        this.$emit("input", alert);
        this.$emit("saved", alert);
      } else {
        const alert = await this.createAlert(
          this.alert.getPostData(),
          REQUEST_TAG
        );
        this.alert.id = alert.id;

        this.$emit("input", alert);
        this.$emit("saved", alert);
      }
    } catch (e) {
      this.$emit("error", e);
    }

    this.busy = false;
  }

  getTaxonomiesToAlertables(): {
    id: string;
    type: string;
  }[] {
    const sectors = this.mapTaxonomyItem(
      this.taxonomies.sector,
      "productSectors"
    );
    const categories = this.mapTaxonomyItem(
      this.taxonomies.category,
      "productCategories"
    );
    const classes = this.mapTaxonomyItem(
      this.taxonomies.class,
      "productClasses"
    );

    return [...sectors, ...categories, ...classes];
  }

  getAlertablesToTaxonomies(): TaxonomyValue {
    const taxonomies: {
      sector: string[];
      category: string[];
      class: string[];
    } = {
      sector: [],
      category: [],
      class: [],
    };

    this.alert.alertables.forEach((alertable) => {
      if (alertable instanceof ProductSector) {
        taxonomies.sector.push(alertable.id);
      }

      if (alertable instanceof ProductCategory) {
        taxonomies.category.push(alertable.id);
      }

      if (alertable instanceof ProductClass) {
        taxonomies.class.push(alertable.id);
      }
    });

    return taxonomies;
  }

  mapTaxonomyItem(
    element: string | string[] | undefined,
    type: string
  ): {
    id: string;
    type: string;
  }[] {
    if (Array.isArray(element)) {
      return (element as []).map((id: string) => {
        return { id: id, type };
      });
    } else if (typeof element === "string") {
      return [{ id: element, type }];
    }
    return [];
  }

  protected showRecipientForm() {
    this.recipientFormVisible = true;
    this.$nextTick(() => {
      (this.$refs.recipientInput as HTMLInputElement).focus();
    });
  }

  protected hideRecipientForm() {
    this.recipientFormVisible = false;
    this.recipient = "";
  }

  protected onFrequencyChange(value: boolean, frequency: string) {
    if (value) {
      this.alert.frequency = frequency;
    }
  }
}
